"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEmpListEntrySchema = exports.createEmpListEntrySchema = exports.empListEntryShape = exports.EMP_LIST_ENTRY_TYPE_LABEL = exports.EMP_LIST_ENTRY_TYPES = exports.empListEntryTypeEnum = void 0;
const zod_1 = require("zod");
const staff_concession_1 = require("../domain/staff-concession");
/**
 * EMP LIST REGISTER (desk, 2026-10-15) - the register of people entitled to the staff concession / credit
 * facility: Staff, Retired Staff, Student and Dependent. See `EmpListEntry` in the Prisma schema for why it is
 * a register of its own and not the Employee master.
 *
 * THE CROSS-FIELD RULES LIVE IN `superRefine`, ON CREATE:
 *   STAFF      needs a staff number (the hospital's EMPNO).
 *   DEPENDENT  needs the staff member it belongs to and how they are related; a son or daughter also needs a
 *              date of birth, because the concession rule is "not above 21 years".
 * The server repeats every one of them against the stored row on create AND update (`EmpListService`), so this
 * is the readable early answer, not the only guard.
 */
exports.empListEntryTypeEnum = zod_1.z.enum(['STAFF', 'RETIRED', 'STUDENT', 'DEPENDENT']);
exports.EMP_LIST_ENTRY_TYPES = exports.empListEntryTypeEnum.options;
/** The words the desk uses for each type, in the order it says them. */
exports.EMP_LIST_ENTRY_TYPE_LABEL = {
    STAFF: 'Staff',
    RETIRED: 'Retired staff',
    STUDENT: 'Student',
    DEPENDENT: 'Dependent',
};
const optionalText = (max) => zod_1.z.string().trim().max(max).nullable().optional();
exports.empListEntryShape = {
    entryType: exports.empListEntryTypeEnum,
    /** The hospital's own staff number (EMLIST EMPNO). Required for STAFF. */
    staffNumber: optionalText(30),
    name: zod_1.z.string().trim().min(1, 'Name is required').max(255),
    /** DEPENDENT only: the STAFF row this person belongs to. */
    staffEntryId: zod_1.z.string().uuid().nullable().optional(),
    /** DEPENDENT only. Same three the concession rule knows. */
    relation: zod_1.z.enum(staff_concession_1.DEPENDENT_RELATIONS).nullable().optional(),
    dateOfBirth: zod_1.z.coerce.date().nullable().optional(),
    /** Staff: department. Student: course / institution. Free text. */
    department: optionalText(150),
    mobileNumber: optionalText(20),
    remarks: optionalText(500),
    isActive: zod_1.z.boolean().optional(),
};
const base = zod_1.z.object(exports.empListEntryShape);
exports.createEmpListEntrySchema = base.superRefine((value, ctx) => {
    if (value.entryType === 'STAFF' && !value.staffNumber?.trim()) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['staffNumber'], message: 'Staff number is required for a staff member' });
    }
    if (value.entryType === 'DEPENDENT') {
        if (!value.staffEntryId) {
            ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['staffEntryId'], message: 'Choose the staff member this dependent belongs to' });
        }
        if (!value.relation) {
            ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['relation'], message: 'Choose the relation to the staff member' });
        }
        if ((value.relation === 'SON' || value.relation === 'DAUGHTER') && !value.dateOfBirth) {
            ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['dateOfBirth'], message: 'Date of birth is required for a son or daughter' });
        }
    }
});
/** Partial: the stored row supplies what is not sent, and the server re-checks the merged result. */
exports.updateEmpListEntrySchema = base.partial();
//# sourceMappingURL=emp-list.schema.js.map